import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Preference } from '../_models/preference';

@Injectable()
export class FieldViewService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryServiceUrl = environment.telemetryServiceUrl;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient
  ) {}

  getFieldViewConnectionStatus(): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/isLeafUserConnected?externalSource=CLIMATEFIELDVIEW'
      )
      .pipe(map((response) => response));
  }

  getFieldViewConnectionUrl(): Observable<string> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/withLeafAuthenticate?externalSource=CLIMATEFIELDVIEW&redirect_uri=' +
          this.document.baseURI
      )
      .pipe(map((response) => response));
  }

  getImportedFieldsFromFV(): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/importLeafFields?externalSource=CLIMATEFIELDVIEW'
      )
      .pipe(map((response) => response));
  }

  getImportedCropsFromFV(): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/importLeafCrops?externalSource=CLIMATEFIELDVIEW'
      )
      .pipe(map((response) => response));
  }

  setPreferenceOnResource(preference: Preference): Observable<any> {
    return this.http
      .post(
        this.telemetryServiceUrl +
          'api/private/v3/machine/preference?externalSource=CLIMATEFIELDVIEW',
        preference
      )
      .pipe(map((response) => response));
  }

  exportFieldsForFV(): Observable<any> {
    return this.http
      .post<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/exportFieldsToProviders?externalSource=CLIMATEFIELDVIEW&all=true',
        null
      )
      .pipe(map((response) => response));
  }

  disconnectFieldView(): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/disconnectProvider?externalSource=CLIMATEFIELDVIEW'
      )
      .pipe(map((response) => response));
  }
}
